/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Event_Trigger_Records_LabelInputs */



/**
* | output |
* | --- |
* | "Which records?" |
*
* @param {Agent_Event_Trigger_Records_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_trigger_records_label = /** @type {((inputs?: Agent_Event_Trigger_Records_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Trigger_Records_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Welche Datensätze?")
	return /** @type {LocalizedString} */ ("Which records?")
});